
import Vue from 'vue';

// Components
import BaseCard from '../components/BaseCard.vue';
import WidgetModule from '~/components/smart/WidgetModule.vue';
import AccountDetails from '../components/settings/AccountDetails.vue';
import DeleteAccount from '../components/settings/DeleteAccount.vue';

export default Vue.extend({
    name: 'Settings',
    components: { BaseCard, WidgetModule, AccountDetails, DeleteAccount },
});
